// node_modules
import axios from "axios";
import { LoggingConstants } from "Constants";
import { SynonymTypeEnum } from "Enums";
// Helpers
import { AxiosHelperSingleton, PendoHelperSingleton } from "Helpers";
import { TSynonymDTO } from "Types";
// Types

export class SynonymController {

    public async createAsync(text: string, synonymType: SynonymTypeEnum, parentElementId: number, isFromDelivery: boolean): Promise<TSynonymDTO> {
        const formData = new FormData();
        formData.append("isFromDelivery", isFromDelivery ? "true" : "false");
        formData.append("text", text);
        formData.append("parentElementId", parentElementId.toString());
        formData.append("synonymType", synonymType.toString());
        
        PendoHelperSingleton.trackEventWithProperties(`${LoggingConstants.DYNAMIC_DELIVERY}SynonymCreate`, {
            parentElementId: parentElementId
        });
        
        const result = await axios.post<TSynonymDTO>(`${AxiosHelperSingleton.getServerBaseURL()}api/synonyms/Create`,
            formData, { headers: { "Content-Type": "multipart/form-data" } });
        return result.data;
    }

    public async updateAsync(synonym: TSynonymDTO, isFromDelivery: boolean): Promise<boolean> {
        PendoHelperSingleton.trackEventWithProperties(`${LoggingConstants.DYNAMIC_DELIVERY}SynonymUpdate`, {
            synonymId: synonym.id
        });
        
        const result = await axios.put(`${AxiosHelperSingleton.getServerBaseURL()}api/synonyms?isFromDelivery=${isFromDelivery ? "true" : "false"}`,
            synonym);
        return result.status === 200;
    }

    public async deleteAsync(synonymId: number, isFromDelivery: boolean): Promise<boolean> {
        PendoHelperSingleton.trackEventWithProperties(`${LoggingConstants.DYNAMIC_DELIVERY}SynonymDelete`, {
            synonymId: synonymId
        });
        
        const result = await axios.delete(`${AxiosHelperSingleton.getServerBaseURL()}api/synonyms/${synonymId}?isFromDelivery=${isFromDelivery ? "true" : "false"}`);
        return result.status === 200;
    }

    public async retrieveGeneratedSynonyms(text: string, type: number, elementId?: string): Promise<string[] | undefined> {
        try {
            // Log the synonym retrieval
            PendoHelperSingleton.trackEvent(`${LoggingConstants.DYNAMIC_DELIVERY}SynonymGenerate`);
            
            // Retrieve the generated synonyms from the server
            const result = await axios.get<string[]>(`${AxiosHelperSingleton.getServerBaseURL()}api/synonyms/generate`, {
                params: {
                    text,
                    type,
                    elementId
                }
            });
            return result.data;
        } catch (error: unknown) {
            // If something went wrong with the request than return an empty list
            // TODO: determine how to handle different errors and show an toast
            return undefined;
        }

    }

    public async retrieveHistoricalSynonyms(text: string, type: number, elementId?: string): Promise<string[] | undefined> {
        try {
            // Log the synonym retrieval
            PendoHelperSingleton.trackEvent(`${LoggingConstants.DYNAMIC_DELIVERY}SynonymHistorical`);

            // Retrieve the generated synonyms from the server
            const result = await axios.get<string[]>(`${AxiosHelperSingleton.getServerBaseURL()}api/synonyms/historical`, {
                params: {
                    text,
                    type,
                    elementId
                }
            });
            return result.data;
        } catch (error: unknown) {
            // If something went wrong with the request than return an empty list
            // TODO: determine how to handle different errors and show an toast
            return undefined;
        }

    }
}

export const SynonymControllerSingleton = new SynonymController();